//
// Sometimes the sitefinity validation kicks in on hidden fields (a bug imo..) that's why we populate some random value which we then ignore..
//

var hiddenSelectsValidationWorkaroundInit = (function () {
    'use strict';

    var selects = document.querySelectorAll('select');

    function init() {
        $(selects).on("invalid", function () {
            var container = $(this).closest('[data-sf-role="dropdown-list-field-container"]');
            if (container.css("display") == "none") {
                var exampleValue = $(this).children().last().val();
                $(this).val(exampleValue).change();

                var nextButton = $(this).closest('[data-sf-role="separator"]').find('[data-sf-btn-role="next"]');

                var curr = this;

                setTimeout(function () {
                    nextButton.click();
                    $(curr).val("");
                }, 30);
            }
        });
    }

    if (selects.length) {
        init();
    }
})();
